<section class="faq-section">
	<h2 class="faq-title">{{ faqConstants.title }}</h2>

	<!-- Search Bar -->
	<div class="faq-search">
		<i class="fa fa-search"></i>
		<input type="text" [(ngModel)]="searchTerm" [placeholder]="faqConstants.searchPlaceholder" />
	</div>

	<!-- FAQ List -->
	<div class="faq-list">
		<div class="faq-item" *ngFor="let faq of filteredFaqs; let i = index">
			<button class="faq-question" (click)="toggleFaq(faq)">
				{{ faq.question }}
				<span class="faq-icon">
					<i class="fas" [ngClass]="faq.open ? 'fa-minus' : 'fa-plus'"></i>
				</span>
			</button>
			<div class="faq-answer" *ngIf="faq.open">
				<p [innerHTML]="faq.answer"></p>
			</div>
		</div>
	</div>
</section>
